@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.button-container {
  display: inline-flex;
}

.create-and-print-label-button {
  margin-left: 10px;
}

.button-styles {
  border-right: 1px solid var(--white);
  display: flex;
  padding: 4px 12px;

  &:disabled {
    border-right: 1px solid var(--gray-8D9196);
  }
}

.drop-down-menu-button {
  border-radius: 0 3px 3px 0;

  svg {
    fill: var(--white);
  }

  &:disabled {
    svg {
      fill: var(--gray-8D9196);
    }
  }
}

.dropdown-menu {
  max-width: none;
}
